<svg width="288" height="288" aria-hidden="true">
  <circle cx="70" cy="20" r="1" fill="white">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="4.1s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="50" cy="69" r="1" fill="yellow">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="2.3s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="35" cy="120" r="1" fill="yellow">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="1.9s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="23" cy="190" r="1" fill="white">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="3.7s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="28" cy="210" r="1" fill="red">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="1.9s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="70" cy="253" r="1" fill="white">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="1.7s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="30" cy="243" r="1" fill="white">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="2.9s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="144" cy="30" r="1" fill="white">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="1.8s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="144" cy="273" r="1" fill="white">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="4.7s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="230" cy="25" r="1" fill="white">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="2.4s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="230" cy="50" r="1" fill="yellow">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="3.4s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="275" cy="150" r="1" fill="yellow">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="1.8s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="223" cy="220" r="1" fill="white">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="2.7s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="228" cy="230" r="1" fill="red">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="2.9s"
      repeatCount="indefinite"
    />
  </circle>
  <circle cx="250" cy="253" r="1" fill="white">
    <animate
      attributeName="opacity"
      values="1;0;1"
      dur="1.7s"
      repeatCount="indefinite"
    />
  </circle>
</svg>

<style>
  svg {
    grid-area: center;
  }
</style>
